import styled from "styled-components";

const Container = styled.div`
  padding: 96px 20px 56px;
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SectionCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #eef0f3;
  }

  .card-header .card-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #002951;
  }

  .card-header .card-chip {
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #ffffff;
    background: #597aa7;
    padding: 3px 10px;
    border-radius: 20px;
  }

  .card-body {
    padding: 2px 20px 6px;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #f1f3f5;

  &:last-child {
    border-bottom: none;
  }

  .label {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .label .title {
    font-size: 0.95rem;
    font-weight: 500;
    color: #1b1b1b;
  }

  .label .helper {
    font-size: 0.78rem;
    color: rgb(0 0 0 / 55%);
    max-width: 460px;
    line-height: 1.35;
  }

  .control {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
`;

export { Container, SectionCard, OptionContainer };
